import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./Component/Header";
import ScrollToTop from "./Page/ScrollToTop"; 

import Main_Home_Page from "./Page/MainHome_Page";
import About_Page from "./Page/About_Page";
import Contact_Page from "./Page/Contact_Page";
import Carrer_Page from "./Page/Carrer_Page";
import StudentForm from './Page/StudentForm' 
import Certificate from "./Component/Certificate";
import DemoForm from "./Component/DemoSessionForm";
import ProgramsPage from './Component/Programs/ProgramsPage';
import AADPage from "./Component/Programs/android-app-development/AADPage";
import ARVRPage from "./Component/Programs/ar-vr/ARVRPage";
import AIPage from "./Component/Programs/artificial-intelligence/AIPage";
import ACPage from "./Component/Programs/autocad/ACPage";
import BIPage from "./Component/Programs/bio-informatics/BIPage";
import BAPage from "./Component/Programs/business-analytics/BAPage";
import CDPage from "./Component/Programs/car-design/CDPage";
import CCPage from "./Component/Programs/cloud-computing/CCPage";
import CSPage from "./Component/Programs/cyber-security/CSPage";
import DSPage from "./Component/Programs/data-science/DSPage";
import DAPage from "./Component/Programs/data-analytics/DAPage";
import DMPage from "./Component/Programs/digital-marketing/DMPage";
import DEPage from "./Component/Programs/drone-engineering/DEPage";
import DSAPage from "./Component/Programs/dsa/DSAPage";
import ESPage from "./Component/Programs/embedded-systems/ESPage";
import FPage from "./Component/Programs/finance/FPage";
import GAIPage from "./Component/Programs/generative-ai/GAIPage";
import GEPage from "./Component/Programs/genetic-engineering/GEPage";
import GDPage from "./Component/Programs/graphic-design/GDPage";
import HRPage from "./Component/Programs/human-resource/HRPage";
import HEVPage from "./Component/Programs/hybrid-electric-vehicle/HEVPage";
import ICEPage from "./Component/Programs/ic-engine/ICEPage";
import IOTPage from "./Component/Programs/internet-of-things/IOTPage";
import JFSPage from "./Component/Programs/java-full-stack/JFSPage";
import MLPPage from "./Component/Programs/machine-learning-with-python/MLPPage";
import MERNPage from "./Component/Programs/mern-stack/MERNPage";
import NSNTPage from "./Component/Programs/nanoscience-nanotechnology/NSNTPage";
import PPage from "./Component/Programs/psychology/PPage";
import RAPage from "./Component/Programs/regulatory-affairs/RAPage";
import RPage from "./Component/Programs/robotics/RPage";
import SMPage from "./Component/Programs/stock-market/SMPage";
import SCMPage from "./Component/Programs/supply-chain-management/SCMPage";
import UIUXPage from "./Component/Programs/ui-ux/UIUXPage";
import VLSIPage from "./Component/Programs/vlsi/VLSIPage";
import WDPage from "./Component/Programs/web-development/WDPage";
import Footer from "./Component/Footer";  
import NotFound from "./Page/NotFound";  
// import Home from "./Page/Home";


export default function App() {
  return (
    <BrowserRouter>
      {/* ---- Header will be visible on all pages ---- */}
      <Header />  
       <ScrollToTop />   
      {/* ---- All Routes ---- */}
      <Routes>
        <Route path="/" element={<Main_Home_Page />} /> 
        <Route path="/programs" element={<ProgramsPage />} />  
        <Route path="/about-us" element={<About_Page />} />  
        <Route path="/contact-us" element={<Contact_Page />} />  
        <Route path="/careers" element={<Carrer_Page />} />  
        <Route path="/register" element={<StudentForm />} />  
        <Route path="/certificate" element={<Certificate />} />  
        <Route path="/form" element={<DemoForm />} />  
        <Route path="/android-app-development" element={<AADPage />} />       
        <Route path="/ar-vr" element={<ARVRPage />} />    
        <Route path="/artificial-intelligence" element={<AIPage />} />    
        <Route path="/autocad" element={<ACPage />} />    
        <Route path="/bio-informatics" element={<BIPage />} />    
        <Route path="/business-analytics" element={<BAPage />} />    
        <Route path="/car-design" element={<CDPage />} />    
        <Route path="/cloud-computing" element={<CCPage />} />    
        <Route path="/cyber-security" element={<CSPage />} />    
        <Route path="/data-science" element={<DSPage />} />    
        <Route path="/data-analytics" element={<DAPage />} />    
        <Route path="/digital-marketing" element={<DMPage />} />    
        <Route path="/drone-engineering" element={<DEPage />} />    
        <Route path="/dsa" element={<DSAPage />} />    
        <Route path="/embedded-systems" element={<ESPage />} />    
        <Route path="/finance" element={<FPage />} />    
        <Route path="/generative-ai" element={<GAIPage />} />    
        <Route path="/genetic-engineering" element={<GEPage />} />    
        <Route path="/graphic-design" element={<GDPage />} />    
        <Route path="/human-resource" element={<HRPage />} />    
        <Route path="/hybrid-electric-vehicle" element={<HEVPage />} />    
        <Route path="/ic-engine" element={<ICEPage />} />    
        <Route path="/internet-of-things" element={<IOTPage />} />    
        <Route path="/java-full-stack" element={<JFSPage />} />    
        <Route path="/machine-learning" element={<MLPPage />} />    
        <Route path="/mern-stack" element={<MERNPage />} />    
        <Route path="/nanoscience-nanotechnology" element={<NSNTPage />} />    
        <Route path="/psychology" element={<PPage />} />    
        <Route path="/regulatory-affairs" element={<RAPage />} />    
        <Route path="/robotics" element={<RPage />} />    
        <Route path="/stock-market" element={<SMPage />} />    
        <Route path="/supply-chain-management" element={<SCMPage />} />    
        <Route path="/ui-ux" element={<UIUXPage />} />    
        <Route path="/vlsi" element={<VLSIPage />} /> 
        <Route path="/web-development" element={<WDPage />} />    
        <Route path="*" element={<NotFound/>} />    
        
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
